import React, { useEffect, useState } from 'react'
import { Spin, Result } from 'antd'
import type { FFEDocument } from '../../types/ffe'
import { Organisation } from '../../services/ApiContext'
import { CompletedPurchaseOrder } from '../../types/purchaseOrder'
import { PrintedDocumentLayout } from './PrintedDocumentLayout'

declare global {
  interface Window {
    pdfData?: {
      document?: FFEDocument
      purchaseOrder?: CompletedPurchaseOrder
      organisation: Organisation
    }
  }
}

export const DocumentPrinting: React.FC = () => {
  // const { id } = useParams<{ id?: string }>()
  const [specification, setDocument] = useState<FFEDocument | null>(null)
  const [organisation, setOrganisation] = useState<Organisation | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const loadDocument = async () => {
      try {
        console.log('PrintClient - Starting')
        if (window.pdfData) {
          setDocument(window.pdfData.document!)
          setOrganisation(window.pdfData.organisation)
          document.title =
            'FFE-' +
            (window.pdfData.document!.projectTitle ?? 'Project') +
            new Date().toLocaleDateString()
          setLoading(false)
          console.log('PrintClient - Finished init')
          return
        }
      } catch (err) {
        console.error(err)
        setError(err instanceof Error ? err.message : 'Failed to load document')
      } finally {
        setLoading(false)
      }
    }
    loadDocument()
  }, [])

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Spin size="large" />
      </div>
    )
  }

  if (error || !specification || !organisation) {
    return (
      <Result
        status="error"
        title={
          'Failed to load document' + JSON.stringify(window.pdfData, null, 2)
        }
        subTitle={error || 'Document not found'}
      />
    )
  }

  return (
    <PrintedDocumentLayout
      specification={specification}
      organisation={organisation}
    />
  )
}
